export default {
  path: '/options',
  name: 'options',
  component: () => import('../views/options/Options.vue'),
  meta: {
    layout: 'main',
    breadcrumb: {
      linkTo: 'options',
      linkText: 'Дополнительные опции'
    }
  }
}